/*eslint no-use-before-define:0 */ //TODO REMOVE THIS
let dd = require("ES/lib/dd");
let _ = require("ES/lib/lodash");
let radio = require("ES/lib/radio");
let esUtils = require("ES/utils/esUtils");
let RadioMixin = require("ES/utils/RadioMixin");
let ErrorAlert = require("ES/widgets/ErrorAlert");
let LoadingWrap = require("ES/widgets/LoadingWrap");
let AuthedUserSession = require("../../../utils/AuthedUserSession");

module.exports = dd.createClass({
  mixins: [RadioMixin],
  getInitialState: function () {
    return {
      sid: -1,
      has_zohocrm_connected: null,
      is_reading: false,
      read_error_msg: null,
    };
  },
  componentWillReceiveProps: function (props) {
    this.__loadForSid(props.selected_sid);
  },
  componentDidMount: function () {
    this.__loadForSid(this.props.selected_sid);
  },
  componentWillMount: function () {
    var self = this;
    self.radio = {
      read_Thirdpartyconnection_ZohoCRM_config: function (sid) {
        if (self.state.sid == sid) {
          self.setState({
            has_zohocrm_connected: null,
            is_reading: true,
            read_error_msg: null,
          });
        }
      },
      read_Thirdpartyconnection_ZohoCRM_config_succeeded: function (sid, data) {
        if (self.state.sid == sid) {
          self.setState({
            has_zohocrm_connected: !_.isEmpty(data),
            is_reading: false,
            read_error_msg: null,
          });
        }
      },
      read_Thirdpartyconnection_ZohoCRM_config_failed: function (sid, message) {
        if (self.state.sid == sid) {
          self.setState({
            has_zohocrm_connected: null,
            is_reading: false,
            read_error_msg:
              "Failed to read your ZohoCRM connector settings: " + message,
          });
        }
      },
      remove_Thirdpartyconnection_ZohoCRM_config: function (sid) {
        if (self.state.sid == sid) {
          self.setState({
            has_zohocrm_connected: null,
            is_reading: true,
            read_error_msg: null,
          });
        }
      },
    };
  },
  __loadForSid: function (sid) {
    if (sid != this.state.sid) {
      this.setState(
        {
          sid: sid,
          has_zohocrm_connected: null,
          is_reading: false,
          read_error_msg: null,
        },
        function () {
          radio("read_Thirdpartyconnection_ZohoCRM_config").broadcast(sid);
        }
      );
    }
  },
  __removeZohoCRMConfig: function (sid) {
    let self = this;
    if (sid == this.state.sid) {
      radio("remove_Thirdpartyconnection_ZohoCRM_config").broadcast(
        sid,
        function (sid, data) {
          self.setState({
            has_zohocrm_connected: false,
            is_reading: false,
            read_error_msg: null,
          });
        },
        function (sid, data) {
          self.setState({
            has_zohocrm_connected: true,
            is_reading: false,
            read_error_msg: _.get(data, "message", "Unknown error."),
          });
        }
      );
    }
  },
  render: function () {
    let Displaylists = this.props.Displaylists;
    let speaker = _.find(
      Displaylists && Displaylists.perspeaker,
      function (spkr) {
        return spkr.sid == this.state.sid;
      },
      this
    );

    let connect_url =
      "/balboa3/thirdpartyconnection/configzohocrm/" +
      this.state.sid +
      "/start_oauth?" +
      esUtils.phpCompatibleParams(AuthedUserSession.balboa);

    return dd.div(
      null,
      LoadingWrap(
        { is_loading: this.state.is_reading, glass: true },
        dd.h3(
          null,
          "ZohoCRM connector for ",
          dd.span({ className: "nametag" }, speaker ? speaker.name_full : "...")
        ),
        dd.p(
          { className: "text-muted" },
          "NOTE: The Zoho CRM account you set here is SHARED with every user on this speaker account. Other EventCX users will have access to the Zoho CRM contacts. ",
          "You are changing it for all the users on this eSpeakers account."
        ),
        ErrorAlert({ message: this.state.read_error_msg }),
        this.state.has_zohocrm_connected === true
          ? dd.div(
              null,
              dd.div(
                { className: "alert alert-success" },
                "You are connected to ZohoCRM!"
              ),
              dd.p(
                {},
                dd.a(
                  { href: connect_url },
                  "Click here to CHANGE the ZohoCRM account to which you are connected."
                )
              ),
              dd.p(
                {},
                dd.a(
                  {
                    onClick: this.__removeZohoCRMConfig.bind(
                      this,
                      this.state.sid
                    ),
                  },
                  "Click here to DISCONNECT your ZohoCRM account."
                )
              )
            )
          : dd.div(
              null,
              dd.p(
                null,
                "The link below will take you to Zoho's site, where you can sign in with your ZohoCRM credentials."
              ),
              dd.p(
                null,
                "Zoho will ask if it's OK for eSpeakers to access your contacts, and you should ",
                dd.b(null, "choose ALLOW ACCESS.")
              ),
              dd.a(
                { href: connect_url, className: "btn btn-primary" },
                "Connect to your ZohoCRM account"
              ),
              dd.br(),
              dd.br()
            )
      )
    );
  },
});



// WEBPACK FOOTER //
// ./src/components/account_settings/connect/ZohoCRM.js